var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenu1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1032",
    "data-name": "Group 1032",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 13.943,
    viewBox: "0 0 20 13.943",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_966",
    "data-name": "Rectangle 966",
    width: 20,
    height: 13.943,
    fill: "#7fc558"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1032-2",
    "data-name": "Group 1032",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4542",
    "data-name": "Path 4542",
    d: "M19.977,7.9V4.185a7.708,7.708,0,0,0-.067-1.87A3.146,3.146,0,0,0,18.887.689,3.8,3.8,0,0,0,17.462.044a5.746,5.746,0,0,0-1.2-.022H2.7c-.069.044-.175.019-.267.045a4.438,4.438,0,0,0-.579.178A3.242,3.242,0,0,0,.408,1.535,6.465,6.465,0,0,0,.03,4.652V9.506A8.779,8.779,0,0,0,.1,11.621a3.489,3.489,0,0,0,.534,1.069,1.854,1.854,0,0,0,.289.378,4,4,0,0,0,1.4.779,4.354,4.354,0,0,0,1.135.067H15.592a8.681,8.681,0,0,0,2.093-.067,3.15,3.15,0,0,0,1.625-1.024,3.809,3.809,0,0,0,.646-1.425,5.518,5.518,0,0,0,.022-1.158Zm-2.249,3.941c-.61.453-2.357.289-3.429.289H3.792a4.593,4.593,0,0,1-1-.022,1.421,1.421,0,0,1-.623-.334c-.387-.388-.356-1.084-.356-1.87V6.077H18.2V9.929c0,.859.019,1.554-.468,1.915M18.2,4.3H1.811c0-.886-.081-1.828.423-2.2C2.842,1.638,4.57,1.8,5.64,1.8h8.482c1.051,0,2.988-.165,3.584.267.577.418.5,1.241.49,2.226M3.948,10H7.154V8.214H3.948Z",
    transform: "translate(0 0)",
    fill: "#7fc558",
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu1);
export default __webpack_public_path__ + "static/media/menu1.e4d19d51d86d3587df0cf7f8f0dde84f.svg";
export { ForwardRef as ReactComponent };